/* eslint-disable jsx-a11y/control-has-associated-label */
import Modal from 'react-modal';
import { ISolicitationDuplicatedViewModel } from 'viewModels';
import { toPattern } from 'vanilla-masker';
import { ReactComponent as WarningIcon } from '../../../assets/icons/iconExclamation.svg';
import { Button } from '../../Buttons/Button';
import { ContentModal, Header, SolicitationContainer } from './styles';
import { MASK_PROCESS_NUMBER } from '../../../constants';

interface DuplicateSolicitationProps {
  isOpen: boolean;
  onRequestClose: () => void;
  onSelectOption: (option: 'discard' | 'keep') => void;
  currentSolicitation: ISolicitationDuplicatedViewModel;
  matchSolicitation: ISolicitationDuplicatedViewModel;
}
export function ModalDuplicateSolicitation({
  isOpen,
  currentSolicitation,
  matchSolicitation,
  onRequestClose,
  onSelectOption,
}: DuplicateSolicitationProps) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-solicitation-modal-content">
      <Header>
        <div className="subHeader">
          <WarningIcon />
          <h1>O sistema achou uma uma solicitação parecida!</h1>
        </div>
        <div className="close-div">
          <button type="button" onClick={onRequestClose}>
            x
          </button>
        </div>
      </Header>
      <ContentModal>
        <h3>Sua solicitação</h3>
        <SolicitationContainer>
          <div className="content-information-solicitation">
            <div>
              {currentSolicitation.processNumber && (
                <>
                  <h2>Nº do processo</h2>
                  <p>{toPattern(currentSolicitation.processNumber, MASK_PROCESS_NUMBER)}</p>
                </>
              )}

              <h2 className="content-space">Serviço</h2>
              {currentSolicitation.correspondence && (
                <p>{currentSolicitation.correspondence.name}</p>
              )}
              <h2 className="content-space">Prazo Limite</h2>
              {matchSolicitation.dateLimit && (
                <p>
                  {new Date(matchSolicitation.dateLimit).toLocaleDateString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </p>
              )}
            </div>
            <div>
              <h2>Nº da Pasta</h2>
              <p>{currentSolicitation.folderNumber ?? 'Não informado'}</p>
              <h2 className="content-space">Local</h2>
              <p>
                {currentSolicitation?.address?.street ?? '-'}{' '}
                {currentSolicitation?.address?.number ?? '-'}
              </p>
              <div>
                <h2 className="content-space">Partes</h2>
                {currentSolicitation?.parts &&
                  currentSolicitation.parts.map((name, index) => (
                    <p style={{ display: 'inline' }} key={name}>
                      {name}
                      {index + 1 === matchSolicitation.parts?.length ? '.' : ', '}
                    </p>
                  ))}
              </div>
            </div>
          </div>
        </SolicitationContainer>
        <h3>Solicitação parecida</h3>
        <SolicitationContainer>
          <div className="content-information-solicitation">
            <div>
              <h2>Nº de protocolo</h2>
              <p>{matchSolicitation.protocolNumber}</p>
              <h2 className="content-space">Nº do processo</h2>
              <p>{toPattern(matchSolicitation.processNumber, MASK_PROCESS_NUMBER)}</p>
              <h2 className="content-space">Serviço</h2>
              {matchSolicitation.correspondence && <p>{matchSolicitation.correspondence.name}</p>}
              <h2 className="content-space">Prazo Limite</h2>
              {matchSolicitation.dateLimit && (
                <p>
                  {new Date(matchSolicitation.dateLimit).toLocaleDateString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </p>
              )}
            </div>
            <div>
              <h2>Nº da Pasta</h2>
              <p>{matchSolicitation.folderNumber ?? 'Não informado'}</p>
              <h2 className="content-space">Local</h2>
              <p>
                {matchSolicitation?.address?.street ?? '-'}{' '}
                {matchSolicitation?.address?.number ?? '-'}
              </p>
              <div>
                <h2 className="content-space">Partes</h2>
                {matchSolicitation?.parts &&
                  matchSolicitation.parts.map((name, index) => (
                    <p style={{ display: 'inline' }}>
                      {name}
                      {index + 1 === matchSolicitation.parts?.length ? '.' : ', '}
                    </p>
                  ))}
              </div>
            </div>
          </div>
        </SolicitationContainer>
        <div className="buttonModal">
          <Button
            text="Descartar"
            background="primary"
            onClick={() => onSelectOption('discard')}
            dimensions={{ width: '13rem', height: '1.875rem' }}
          />
          {/* <Button
            text="Prosseguir"
            background="secondary"
            onClick={() => onSelectOption('keep')}
            dimensions={{ width: '13rem', height: '1.875rem' }}
          /> */}
        </div>
      </ContentModal>
    </Modal>
  );
}
